// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const GoToBusinessManager = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.goToBusinessManager"
        description="Go to business manager."
        defaultMessage="Go to Business Manager"
    />
);
GoToBusinessManager.displayName = "GoToBusinessManager";

export const GoToMyLenses = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.goToMyLenses"
        description="Go to my lenses."
        defaultMessage="Go to My Lenses"
    />
);
GoToMyLenses.displayName = "GoToMyLenses";

export const DelayMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.delayMessage"
        description="Delay message."
        defaultMessage="We are currently experiencing delays, so it may take longer than usual to process your lens."
    />
);
DelayMessage.displayName = "DelayMessage";

export const SuccessPageHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.successPageHeader"
        description="Success page header."
        defaultMessage="Your Lens has been submitted and is currently in Review."
    />
);
SuccessPageHeader.displayName = "SuccessPageHeader";

export const SuccessCardTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.successCardTitle"
        description="Success card title."
        defaultMessage="Congratulations!"
    />
);
SuccessCardTitle.displayName = "SuccessCardTitle";

export const SuccessCardMessage = (props: { delayMessage: ReactNode; timeTo: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.successCardMessage"
        description="Success card message."
        defaultMessage=" {delayMessage} &nbsp;We will notify you when your lens is ready! Typically it takes {timeTo} for your Lens to be available."
        values={props}
    />
);
SuccessCardMessage.displayName = "SuccessCardMessage";

export const TimeToAvailabilitySnapchatLens = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.timeToAvailabilitySnapchatLens"
        description="Time to availability snapchat lens."
        defaultMessage="1 - 3 hours"
    />
);
TimeToAvailabilitySnapchatLens.displayName = "TimeToAvailabilitySnapchatLens";

export const TimeToAvailabilitySpectaclesLens = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.timeToAvailabilitySpectaclesLens"
        description="Time to availability spectacles lens."
        defaultMessage="a couple of minutes"
    />
);
TimeToAvailabilitySpectaclesLens.displayName = "TimeToAvailabilitySpectaclesLens";

export const SuccessCallToActionBase = (props: { withBM: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.successCallToActionBase"
        description="Success call to action base."
        defaultMessage="In the meantime, you can manage and check the status of your Lens in My Lenses{withBM}"
        values={props}
    />
);
SuccessCallToActionBase.displayName = "SuccessCallToActionBase";

export const SuccessCallToActionWithBM = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.successfulSubmitPage.successCallToActionWithBM"
        description="Success call to action with b m."
        defaultMessage=" or go to Business Manager to add the Lens to an Ad profile for use as a sponsored Lens!"
    />
);
SuccessCallToActionWithBM.displayName = "SuccessCallToActionWithBM";
